import { BadgeCheck, Instagram, Linkedin, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { SITE } from "../config/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="grain relative overflow-hidden bg-[#022C22] pt-20 pb-8">
      <div className="relative z-[2] mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <div className="flex flex-col gap-12 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <Logo dark />
            <p className="mt-5 max-w-md font-serif text-2xl italic leading-snug text-[#FDFBF7]/85 sm:text-3xl">
              &ldquo;{SITE.tagline}&rdquo;
            </p>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-[#FDFBF7]/55">
              Play-based counselling for children, parents, adults and families — online and
              in-person. Play &middot; Emotion &middot; Growth.
            </p>
          </div>
          <div className="flex flex-col items-start gap-3">
            <a
              href={SITE.mantraCareUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-mantra-care-badge"
              className="flex items-center gap-2 rounded-full border border-[#A7F3D0]/25 bg-[#064E3B]/60 px-4 py-2 text-xs font-semibold text-[#A7F3D0] transition-transform duration-300 hover:-translate-y-0.5"
            >
              <BadgeCheck size={14} /> Verified Psychologist at Mantra Care
            </a>
            <a
              href={SITE.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              className="group flex items-center gap-2 text-sm text-[#FDFBF7]/70 transition-colors hover:text-[#FDFBF7]"
            >
              <Instagram size={15} /> {SITE.instagramHandle}
              <ArrowUpRight size={13} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <a
              href={SITE.linkedinUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin-link"
              className="group flex items-center gap-2 text-sm text-[#FDFBF7]/70 transition-colors hover:text-[#FDFBF7]"
            >
              <Linkedin size={15} /> Jicy Joy on LinkedIn
              <ArrowUpRight size={13} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <a
              href="#contact"
              data-testid="footer-book-link"
              className="group flex items-center gap-2 text-sm font-semibold text-[#FDFBF7] transition-colors hover:text-[#A7F3D0]"
            >
              Book a session
              <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>
        </div>
        <div className="mt-16 flex flex-col gap-3 border-t border-[#FDFBF7]/10 pt-6 text-xs text-[#FDFBF7]/45 sm:flex-row sm:items-center sm:justify-between">
          <span>&copy; {new Date().getFullYear()} Little Serein. All feelings welcome here.</span>
          <span>Founded by a Child Development Practitioner &middot; Mantra Care verified</span>
        </div>
      </div>
    </footer>
  );
}
